﻿import {$$, cookieConsentsLoaded, getAndSetCookieConsents, hide, isHidden, isStrictSite} from '@/Utils';
import {DataAttributes, DataTypeValues} from "@/enums"

export function reCaptchaSuccess() {
    $$(`[data-type=${DataTypeValues.ReCaptcha}]`).forEach(
        x => {
            x.closest("form").classList.remove("form-captcha-invalid")
            x.dispatchEvent(new Event('captchaSuccess'))
        }
    );
}

export function reCaptchaError() {
    $$(`[data-type=${DataTypeValues.ReCaptcha}]`).forEach(
        x => {
            x.closest("form").classList.add("form-captcha-invalid")
            x.dispatchEvent(new Event('captchaError'))
        }
    );
}

export function reCaptchaCallback() {
    window.reCaptchaLoaded = true;
    $$(`[data-type=${DataTypeValues.ReCaptcha}]`).forEach(x => {
        const isNotVisibleReCaptcha = isHidden(x);
        if (x.getAttribute(DataAttributes.ReCaptchaBound) || isNotVisibleReCaptcha) return;
        const compact = x.hasAttribute(DataAttributes.Compact);
        x.setAttribute(DataAttributes.ReCaptchaBound, "true");
        const parameters: ReCaptchaV2.Parameters = {
            sitekey: window.config.reCaptchaSiteKey,
            size: compact ? "compact" : "normal",
            callback: reCaptchaSuccess,
            "expired-callback": reCaptchaError,
            "error-callback": reCaptchaError
        };
        window.grecaptcha.render(x, parameters);
        $$('[name="g-recaptcha-response"]').forEach(x => {
            x.setAttribute("aria-label", "recaptcha-response")
        })
    });
}

export function initReCaptchas() {
    if(isStrictSite && !getAndSetCookieConsents().performance) return
    $$(`[data-type=${DataTypeValues.ReCaptcha}]`).forEach(x => {
        if (x.getAttribute(DataAttributes.ReCaptchaInitialized)) {
            return
        }
        x.setAttribute(DataAttributes.ReCaptchaInitialized, "true")
        // lisame kõik unbound [data-type=reCaptcha] elemendid observerisse
        initRecaptchaObserver.observe(x)
    })
}


function initReCaptchasInternal() {
    if (isStrictSite && !getAndSetCookieConsents().performance) {
        window.addEventListener(cookieConsentsLoaded, initReCaptchasInternal)
        return
    }
    $$(`[data-type=${DataTypeValues.ReCaptchaCookieWarning}]`).forEach(x => hide(x))
    if (window.reCaptchaLoaded) {
        reCaptchaCallback()
    } else {
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?onload=reCaptchaCallback&render=explicit"
        script.defer = true
        script.async = true
        document.head.appendChild(script)
    }
}


const initRecaptchaObserver = new IntersectionObserver(entries => {
    // kui mõni [data-recaptcha] on nähtav, rechaptcha scriptid
    if (entries.some((e) => e.isIntersecting)) {
        initReCaptchasInternal();
    }
}, {threshold: [0]})